import React, { Component } from 'react';
import { connect } from 'react-redux';
import { authContext } from '../../adalConfig';

class ADTesting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            auth: authContext.getCachedUser(),
        };
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    render() {
        console.log(this.state.auth)
        return (
            <div>
                <p>Check developer console for more information.</p>
                <p>Username: {this.state.auth.userName}</p>
            </div>
        );
    }
}

export default connect(
    state => state.adTesting,
)(ADTesting);



// WEBPACK FOOTER //
// ./src/components/testing/ADTesting.js